
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from "react";
import useTranslation from "next-translate/useTranslation";
import Page from "../components/layout/page";
import Head from "next/head";
import Script from "next/script";
export default function PrivacyPolicy() {
    const { t } = useTranslation("common");
    return (<Page title={"Privacy Policy"} className="w-full max-w-none prose dark:prose-dark" padded>
      <Head>
        <title>Chess Hotel | Privacy policy</title>
        <meta name="description" content={t("description")}/>
        <meta name="keywords" content={t("keywords")}/>
      </Head>
      <Script strategy="afterInteractive" dangerouslySetInnerHTML={{
            __html: `let optOutCounter = 0; 
          function setCookie(cname,cvalue,exdays){
            var d = new Date();
            d.setTime(d.getTime()+(exdays*24*60*60*1000));
            var expires='expires='+d.toUTCString();
            document.cookie=cname+'='+cvalue+';'+expires+';path=/'; 
            if(optOutCounter==0){ let cookieP = document.getElementById('cookieP'); 
              var successCookie = document.createElement('strong'); 
              successCookie.innerHTML = 'Optout Success!'; 
              successCookie.setAttribute('style','color:green'); 
              cookieP.appendChild(successCookie); 
              optOutCounter ++ 
            } 
          };`,
        }}/>
      <p>
        <strong>Last updated: August 27, 2026</strong>
      </p>
      <p>
        This privacy policy applies to the Chess Hotel website and the native
        Chess Hotel apps (together, the “Services”) operated by Foggy Media AB.
      </p>
      <h3>Common ID Cookie</h3>
      <p id="cookieP">
        The Chess Hotel website uses cookies and similar tracking technologies
        such as the Common ID cookie to provide its services. Cookies are
        important devices for measuring advertising effectiveness and ensuring a
        robust online advertising industry. The Common ID cookie stores a unique
        user id in the first party domain and is accessible to our ad partners.
        This simple ID that can be utilized to improve user matching, especially
        for delivering ads to iOS and MacOS browsers. Users can opt out of the
        Common ID tracking cookie by clicking{" "}
        <a onClick={() => {
            window.setCookie("_pubcid_optout", "1", 1825);
        }} href="#opt-out">
          here
        </a>
        .
      </p>
      <strong>Advertising Privacy Settings</strong>
      <p>
        FOR EU USERS ONLY: When you use our site, pre-selected companies may
        access and use certain information on your device and about your
        interests to serve ads or personalized content. You may revisit or
        change consent-choices at any time by clicking{" "}
        <a href="#cmp" onClick={() => {
            if (window.__cmp === undefined) {
                console.warn("User is not in the EU - Consent Choices can only be configured when User is in the EU");
            }
            else {
                window.__cmp("showConsentTool");
            }
        }}>
          here
        </a>
        .
      </p>
      <h3>What information do we collect?</h3>
      <p>
        When you create an account, we collect your username, email address,
        password credential, locale or time-zone information, and an approximate
        country code. Passwords are cryptographically hashed and are not stored
        in plain text.
      </p>
      <p>
        If you sign in with Apple, Google, or Facebook, we process the
        authentication credential supplied by that provider and store the
        provider account identifier needed to recognize your Chess Hotel
        account. Those providers process information under their own privacy
        policies.
      </p>
      <p>
        We store activity needed to operate the Services, including chess games
        and moves, ratings, puzzles and progress, friends and leagues, game
        reviews, preferences, avatars, and messages sent through game,
        daily-game, or friend chat.
      </p>
      <p>
        If you enable notifications in the native app, we store an Apple Push
        Notification service device token together with the app version, locale,
        bundle identifier, and notification environment. We use this information
        only to register the installation and deliver requested notifications.
      </p>
      <p>
        When you use an Apple in-app subscription, Apple processes your payment
        information. Chess Hotel receives and validates an App Store receipt and
        stores the resulting membership tier and expiry information. We do not
        receive your payment-card details from Apple.
      </p>
      <p>
        We also process connection and diagnostic information such as IP
        address, app version, locale, timestamps, server requests, and error or
        performance information. You may use parts of the Services as a Guest,
        but connection and gameplay information is still processed to provide
        that session.
      </p>
      <p>
        Third party vendors, including Google, use cookies to serve ads based on
        a user's prior visits to your website or other websites.
      </p>
      <p>
        Google's use of advertising cookies enables it and its partners to serve
        ads to your users based on their visit to your sites and/or other sites
        on the Internet.
      </p>
      <p>
        Users may opt out of personalized advertising by visiting{" "}
        <a href="https://www.google.com/settings/ads">Ads Settings</a>
      </p>
      <h3>What do we use your information for?</h3>
      <p>
        Any of the information we collect from you may be used in one of the
        following ways:{" "}
      </p>
      <p>- To personalize your experience</p>
      <p>
        Your information helps us to better respond to your individual needs.
      </p>
      <p>- To improve and protect the Services</p>
      <p>
        We continually strive to improve our Services based on the information
        and feedback we receive from you.
      </p>
      <p>
        - To provide games, social features, subscriptions, and notifications
      </p>
      <p>- To send periodic emails</p>
      <p>
        The email address you provide may be used to send you information,
        respond to inquiries, and/or other requests or questions.
      </p>
      <h3>How do we protect your information?</h3>
      <p>
        We use transport encryption, password hashing, access controls, and
        other organizational and technical safeguards designed to protect your
        information. No online service can guarantee absolute security.
      </p>
      <h3>How can your data be deleted?</h3>
      <p>
        You can permanently delete your account from Settings in the native app
        or request deletion by emailing david@chesshotel.com. We may retain
        limited information when required for security, fraud prevention,
        accounting, or legal obligations. Deleted data may remain in protected
        backups for a limited period until those backups are rotated.
      </p>
      <h3>Do we use cookies?</h3>
      <p>
        The website uses cookies. Cookies are small files that a site or its
        service provider transfers to your computers hard drive through your Web
        browser (if you allow) that enables the sites or service providers
        systems to recognize your browser and capture and remember certain
        information.
      </p>
      <p>
        We use cookies to understand and save your preferences for future
        visits. The native app uses local device storage for app preferences and
        authentication state rather than browser advertising cookies.
      </p>
      <h3>Do we disclose any information to outside parties?</h3>
      <p>
        We do not sell, trade, or otherwise transfer to outside parties your
        personally identifiable information. This does not include trusted third
        parties who assist us in operating our website, conducting our business,
        or servicing you, so long as those parties agree to keep this
        information confidential. We may also release your information when we
        believe release is appropriate to comply with the law, enforce our site
        policies, or protect ours or others rights, property, or safety.
        However, non-personally identifiable visitor information may be provided
        to other parties for marketing, advertising, or other uses.
      </p>
      <h3>Third party links</h3>
      <p>
        {" "}
        Occasionally, at our discretion, we may include or offer third party
        products or services on our website. These third party sites have
        separate and independent privacy policies. We therefore have no
        responsibility or liability for the content and activities of these
        linked sites. Nonetheless, we seek to protect the integrity of our site
        and welcome any feedback about these sites.
      </p>
      <h3>California Online Privacy Protection Act Compliance</h3>
      <p>
        Because we value your privacy we have taken the necessary precautions to
        be in compliance with the California Online Privacy Protection Act. We
        therefore will not distribute your personal information to outside
        parties without your consent.
      </p>
      <p>
        As part of the California Online Privacy Protection Act, all users of
        our site may make any changes to their information at anytime by logging
        into their control panel and going to the 'Edit Profile' page.
      </p>
      <h3>Website and App Privacy Policy</h3>{" "}
      <p>
        This policy covers information collected through the Chess Hotel website
        and native apps.
      </p>
      <h3>Terms and Conditions</h3>{" "}
      <p>
        Please also visit our Terms and Conditions section establishing the use,
        disclaimers, and limitations of liability governing the use of our
        website at{" "}
        <a href="https://www.chesshotel.com/termsofservice/">
          https://www.chesshotel.com/termsofservice
        </a>
      </p>
      <h3>Your Consent</h3>
      <p>By using our site, you consent to our privacy policy.</p>
      <h3>Changes to our Privacy Policy</h3>
      <p>
        If we decide to change our privacy policy, we will post those changes on
        this page.
      </p>
      <h3>Contacting Us</h3>
      <p>
        If there are any questions regarding this privacy policy you may contact
        us using the information below.
      </p>
      <p>
        <a className="no-underline" href="mailto:david@chesshotel.com">
          David Shore
        </a>
        <br />
        Foggy Media AB
        <br />
        Stockholm, Sweden
      </p>
    </Page>);
}

    async function __Next_Translate__getStaticProps__1a0fc0d5095__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/privacypolicy',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a0fc0d5095__ as getStaticProps }
  